import {
  PrimaryBigButton,
  SecondaryBigButton
} from 'components/ReusableComponents/Button/BigButtons'
import EditableHotelList from 'components/ReusableComponents/EditableHotelList'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import FormGroup from 'components/ReusableComponents/ManageHotel/FormGroup'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { Redirect } from 'react-router-dom'
import contractApi from 'services/api/contracts'

import ContactHistoryDialog from './ContactHistoryDialog'
import styles from './EditGroupContract.module.scss'

const EditIndependentContract = () => {
  const { subsidiaryId } = useParams()

  const isCreate = !subsidiaryId

  const [isLoading, setIsLoading] = useState(true)
  const [lastUpdatedOn, setLastUpdatedOn] = useState('')
  const [merchantContact, setMerchantContact] = useState()
  const [contactHistories, setContactHistories] = useState([])
  const [isContactHistoryDialogVisible, setIsContactHistoryDialogVisible] =
    useState(false)

  const [hotels, setHotels] = useState([])
  const history = useHistory()

  const getData = React.useCallback(() => {
    setIsLoading(true)

    contractApi.internalAdmin
      .get({ merchantId: -100, subsidiaryId })
      .then(response => {
        const { updatedOn, contacts, contactHistories, hotels } = response
        setLastUpdatedOn(updatedOn)
        setMerchantContact(contacts[0])
        setContactHistories(contactHistories)

        if (!isCreate) setHotels(hotels)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [isCreate, subsidiaryId])

  useEffect(() => {
    getData()
  }, [getData])

  function handleSave() {
    setIsLoading(true)
    getData()
  }

  if (isCreate && hotels.length === 1) {
    return <Redirect to={`/contracts/edit/s/${hotels[0].id}`} />
  }

  return (
    <div className={styles.wrapper}>
      {isContactHistoryDialogVisible && (
        <ContactHistoryDialog
          contacts={[
            {
              ...merchantContact,
              isActive: true
            },
            ...contactHistories
          ]}
          handleClose={() => setIsContactHistoryDialogVisible(false)}
        />
      )}
      {isLoading && <LoadingIndicator />}
      <CustomHeader
        title={isCreate ? 'Add new contract' : hotels[0]?.hotelName}
        width={830}
        isFixed
      />

      <FormGroup title="Hotel" disabled={isLoading} contentPadding="0">
        <EditableHotelList
          initialHotels={hotels}
          onChange={setHotels}
          isEditable={hotels.length === 0}
          merchantId={-100}
          showUsers
          onNewUserAdded={getData}
        />
      </FormGroup>
      <div className={styles.bottomBar}>
        <div className={styles.bottomBarContainer}>
          <p className={styles.lastSavedText}>
            Last saved on {moment(lastUpdatedOn).format('MMM DD, YYYY, hh:MM A')}
          </p>
          <div className={styles.bottomBarButtonsHolder}>
            <SecondaryBigButton onClick={() => history.push('/contracts/list')}>
              Cancel
            </SecondaryBigButton>
            <PrimaryBigButton onClick={() => handleSave()}>Save changes</PrimaryBigButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditIndependentContract
